"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeefyDepositRecipe = void 0;
const recipe_1 = require("../../recipe");
const steps_1 = require("../../../steps");
const beefy_1 = require("../../../api/beefy");
const beefy_deposit_step_1 = require("../../../steps/vault/beefy/beefy-deposit-step");
const min_gas_limits_1 = require("../../../models/min-gas-limits");
class BeefyDepositRecipe extends recipe_1.Recipe {
    constructor(vaultID) {
        super();
        this.config = {
            name: 'Beefy Vault Deposit',
            description: 'Auto-approves and deposits tokens into a yield-bearing Beefy Vault.',
            minGasLimit: min_gas_limits_1.MIN_GAS_LIMIT_BEEFY_VAULT_DEPOSIT,
        };
        this.vaultID = vaultID;
    }
    supportsNetwork(networkName) {
        return beefy_1.BeefyAPI.supportsNetwork(networkName);
    }
    async getInternalSteps(firstInternalStepInput) {
        const { networkName } = firstInternalStepInput;
        const vault = await beefy_1.BeefyAPI.getBeefyVaultForID(this.vaultID, networkName);
        const spender = vault.vaultContractAddress;
        const depositERC20Info = {
            tokenAddress: vault.depositERC20Address,
            decimals: vault.depositERC20Decimals,
        };
        return [
            new steps_1.ApproveERC20SpenderStep(spender, depositERC20Info),
            new beefy_deposit_step_1.BeefyDepositStep(vault),
        ];
    }
}
exports.BeefyDepositRecipe = BeefyDepositRecipe;
